export default {
    timestamp: 'Today is {ts}',
    welcome: 'Welcome to the Trendmanager, {name}'
}
